module.exports = __webpack_public_path__ + "static/media/facebook.84c71750336a5c9e165a71d594628e0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/facebook.png
// module id = 2650
// module chunks = 1